import "./ShowOrderInfo.scss"
import React from "react";
import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateToPersianDate
} from "@moeindal/base-raiko-panel-components";


export default function ShowOrderInfo(
    {
        ages,
        firstName,
        lastName,
        phoneNumber,
        nationalCode,
        gender,
        birthdate,
        totalPaidAmount,
        status,
    }) {


    return (
        <div className={"showOrderInfoLayout"}>
            <div className={"showOrderInfoTitleContainer"}>
                <span className={"showOrderInfoTitle"}>
                    <div className={"ic-travels"}/>
                    {ages}
                </span>
                {status && <span className={"orderState"}> {status === "SUBMITTED" ? "نهایی شده" : "استرداد"}</span>}
            </div>
            <div className={"showOrderInfoContent"}>
                <div className={"showOrderPaidItemContainer"}>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>نام</span>
                        <span className={"orderAttributeValue"}>{firstName}</span>
                    </span>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>نام خانوادگی</span>
                        <span className={"orderAttributeValue"}>{lastName}</span>
                    </span>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>شماره همراه</span>
                        <span className={"orderAttributeValue"}>{phoneNumber}</span>
                    </span>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>مبلغ</span>
                        <span
                            className={"orderAttributeValue"}>{convertCurrencyFormatPositiveNegative(totalPaidAmount)} تومان</span>
                    </span>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>کد ملی</span>
                        <span className={"orderAttributeValue"}>{nationalCode}</span>
                    </span>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>جنسیت</span>
                        <span className={"orderAttributeValue"}>{gender === "MALE" ? "مرد" : "زن"}</span>
                    </span>
                    <span className={"orderAttribute"}>
                        <span className={"orderAttributeTitle"}>تاریخ تولد</span>
                        <span
                            className={"orderAttributeValue"}>{birthdate && birthdate.length >= 10 ? convertUniversalDateToPersianDate(birthdate) : "-"}</span>
                    </span>

                </div>

            </div>

        </div>
    )
}